<div class="dx-grid-container" id="dx-grid">
  <dx-load-panel
    [hideOnOutsideClick]="false"
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="loading"
  >
  </dx-load-panel>
  <app-panel [footer]="false" [backArrow]="false" *ngIf="focalId == 1">
    <div class="heading">Both</div>
    <div class="body">
      <div class="row">
        <div class="col-md-12">
          <div class="upload-csv">
            <button type="button" mat-button (click)="csvfileInput.click()"
            matTooltip="directly upload csv file" matTooltipPosition="left">
            <i class="material-icons">cloud_upload</i>
            <span class="ml-2">Upload CSV</span>
            <input #csvfileInput type="file" accept=".csv" (change)="readCSV($event, 'pivotListBoth')" style="display:none;" />
          </button>

          <div class="grand-total">Total : {{pivotListBothTotal}}</div>
          </div>
          <dx-data-grid id="grid-scroller"
            [dataSource]="pivotListBoth"
            [allowColumnReordering]="true"
            [allowColumnResizing]="true"
            [hoverStateEnabled]="true"
            [remoteOperations]="true"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [customizeColumns]="customizeColumns"
            (onEditingStart)="setColumnDataType($event)" (onExporting)="onExporting($event, 'Both')"
          >
          <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>
          <dxo-paging [pageSize]="100"></dxo-paging>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-header-filter [visible]="false"></dxo-header-filter>
            <dxo-column-chooser
              [enabled]="true"
              mode="select"
            ></dxo-column-chooser>
            <!-- <dxo-pager
              [showPageSizeSelector]="true"
              [showInfo]="true"
              [allowedPageSizes]="[5, 10, 20]"
            ></dxo-pager> -->
            <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
            <dxo-export [enabled]="true" fileName="both" ></dxo-export>
          </dx-data-grid>
        </div>
      </div>
    </div>
  </app-panel>
  <app-panel
    [footer]="false"
    [backArrow]="false"
    *ngIf="focalId != 1 && focalId > 0"
  >
    <div class="heading">Right</div>
    <div class="body">
      <div class="row">
        <div class="col-md-12">
          <div class="upload-csv">
            <button type="button" mat-button (click)="csvfileInput.click()"
            matTooltip="directly upload csv file" matTooltipPosition="left">
            <i class="material-icons">cloud_upload</i>
            <span class="ml-2">Upload CSV</span>
            <input #csvfileInput type="file" accept=".csv" (change)="readCSV($event, 'pivotListRight')" style="display:none;" />
          </button>
          <div class="grand-total">Total : {{pivotListRightTotal}}</div>
          </div>
          <dx-data-grid id="grid-scroller" 
            [dataSource]="pivotListRight"
            [allowColumnReordering]="true"
            [allowColumnResizing]="true"
            [hoverStateEnabled]="true"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [customizeColumns]="customizeColumns"
            (onEditingStart)="setColumnDataType($event)" (onExporting)="onExporting($event, 'Right')" 
          >
          <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>
          <dxo-paging [pageSize]="100"></dxo-paging>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-header-filter [visible]="false"></dxo-header-filter>
            <dxo-column-chooser
              [enabled]="true"
              mode="select"
            ></dxo-column-chooser>
            <!-- <dxo-pager
              [showPageSizeSelector]="true"
              [showInfo]="true"
              [allowedPageSizes]="[5, 10, 20]"
            ></dxo-pager> -->
            <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
            <dxo-export [enabled]="true" fileName="right"></dxo-export>
          </dx-data-grid>
        </div>
      </div>
    </div>
  </app-panel>

  <div class="mt-3"></div>
  <app-panel
    [footer]="false"
    [backArrow]="false"
    *ngIf="focalId != 1 && focalId > 0"
  >
    <div class="heading">Left</div>
    <div class="body">
      <div class="row">
        <div class="col-md-12">
          <div class="upload-csv">
            <button type="button" mat-button (click)="csvfileInput.click()"
            matTooltip="directly upload csv file" matTooltipPosition="left">
            <i class="material-icons">cloud_upload</i>
            <span class="ml-2">Upload CSV</span>
            <input #csvfileInput type="file" accept=".csv" (change)="readCSV($event, 'pivotListLeft')" style="display:none;" />
          </button>
          <div class="grand-total">Total : {{pivotListLeftTotal}}</div>
          </div>
          <dx-data-grid id="grid-scroller"
            [dataSource]="pivotListLeft"
            [allowColumnReordering]="true"
            [allowColumnResizing]="true"
            [hoverStateEnabled]="true"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [customizeColumns]="customizeColumns" (onExporting)="onExporting($event, 'Left')" 
          >
          <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>
          <dxo-paging [pageSize]="100"></dxo-paging>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-header-filter [visible]="false"></dxo-header-filter>
            <dxo-column-chooser
              [enabled]="true"
              mode="select"
            ></dxo-column-chooser>
            <!-- <dxo-pager
              [showPageSizeSelector]="true"
              [showInfo]="true"
              [allowedPageSizes]="[5, 10, 20]"
            ></dxo-pager> -->
            <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
            <dxo-export [enabled]="true" fileName="left"></dxo-export>
          </dx-data-grid>
        </div>
      </div>
    </div>
  </app-panel>
  <div class="mt-3"></div>
  <dx-speed-dial-action *ngIf="!isViewOnly"
    icon="add"
    label="Save"
    [index]="1"
    (onClick)="savebothSidesForm()"
  >
  </dx-speed-dial-action>
</div>
